import React from "react";

const VARIANT_STYLES = {
  filled: "bg-pd-blue-new text-white hover:bg-pd-blue-dark",
  outline: "bg-white border text-[#414651] border-[#D5D7DA] hover:bg-grey-100",
  error: "bg-error text-white hover:bg-error/90",
  default: "bg-pd-blue-new",
};

const SIZE_STYLES = {
  sm: "px-8 py-4 text-xs rounded-sm",
  md: "px-2 py-1 text-sm rounded-sm",
  lg: "px-2.5 py-1.5 text-sm rounded-md",
  xl: "px-12 py-8 text-16 rounded-md",
  "2xl": "px-3.5 py-2.5 text-16 rounded-md",
  full: "w-full px-3.5 py-2.5 text-16 rounded-md",
};

const SquaredButton = ({
  children,
  onClick,
  variant = "filled",
  size = "sm",
  type = "button",
  ...props
}) => {
  const baseStyles =
    "font-semibold shadow-xs focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-pd-blue-new disabled:opacity-30";
  const variantStyle = VARIANT_STYLES[variant] || VARIANT_STYLES.default;
  const sizeStyle = SIZE_STYLES[size];

  if (!sizeStyle) return null;

  return (
    <button
      className={`${baseStyles} ${variantStyle} ${sizeStyle}`}
      onClick={onClick}
      // eslint-disable-next-line react/button-has-type
      type={type}
      {...props}
    >
      {children}
    </button>
  );
};

export default SquaredButton;
